import type { RegionIssueAlertFragment } from "../client/generated";
import { useTranslation } from "react-i18next";
import { Icon } from "@mdi/react";
import { mdiAlert } from "@mdi/js";
import { Alert, AlertTitle } from "@acdc2/ui/components/alert";

type Props = {
  fragment: RegionIssueAlertFragment;
};

export function RegionIssueAlert({ fragment }: Props) {
  const { t } = useTranslation();

  return (
    <Alert>
      <Icon path={mdiAlert} size="1rem" />
      <AlertTitle>{t(`RegionIssueAlert.title.${fragment.type}`)}</AlertTitle>
    </Alert>
  );
}
